export default {
    getQhses: (state) => state.qhses,
  }